import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export interface topTerminalStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

/** 域名访问管控 - 终端拦截次数 TOP 列表单项 */
export interface TopDomainAccessTerminalItem {
  /** 终端名称 */
  computer_name: string
  /** 所属部门 */
  department: string
  /** 拦截次数 */
  block_count: number
  /** 终端 ID（若接口返回则排行点击可直接详情） */
  device_id?: string
}

export interface topTerminalStatResponseData {
  /** 终端拦截次数 TOP 列表 */
  top_terminal_list: TopDomainAccessTerminalItem[]
}

export interface topDomainStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

export interface TopDomainList {
  /** 域名 */
  domain: string
  /** 拦截次数 */
  block_count: number
}

export interface topDomainStatResponseData {
  /** 域名拦截次数TOP列表 */
  top_domain_list: TopDomainList[]
}

export interface overviewStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
}

export interface overviewStatResponseData {
  /** 今日拦截域名数量 */
  today_blocked_domain_count: number
  /** 已生效策略数量 */
  active_policy_count: number
}
export interface categoryRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

export interface TopCategoryList {
  /** 域名分类名称 */
  category_name: string
  /** 占比（百分比数值，如60代表60%） */
  ratio: number
}

export interface categoryResponseData {
  /** 上网分类占比TOP列表 */
  top_category_list: TopCategoryList[]
}
export interface DomainsRequestParams {
  /** 分类ID */
  category_id: number
}

export interface DomainsResponseData {
  /** 域名列表 */
  domain_list: string[]
}
export interface CategoryList {
  /** 分类ID */
  category_id: number
  /** 分类名称 */
  category_name: string
}

export interface CategoryResponseData {
  /** 域名分类列表 */
  category_list: CategoryList[]
}
@Injectable()
export class TimeViewService {
  constructor(private http: Http) {
  }

  getTerminalDomainaccessTopTerminalStat (data: topTerminalStatRequestParams) {
    return this.http.post<topTerminalStatResponseData>('/terminal/domainaccess/top-terminal-stat', data)
  }
  getTerminalDomainaccessTopDomainStat (data: topDomainStatRequestParams) {
    return this.http.post<topDomainStatResponseData>('/terminal/domainaccess/top-domain-stat', data)
  }
  getTerminalDomainaccessOverviewStat (data: overviewStatRequestParams) {
    return this.http.post<overviewStatResponseData>('/terminal/domainaccess/overview-stat', data)
  }
  getTerminalDomainaccessTopCategoryStat (data: categoryRequestParams) {
    return this.http.post<categoryResponseData>('/terminal/domainaccess/top-category-stat', data)
  }
  // 根据分类ID查询域名列表
  getTerminalDomainCategoryDomains (data: DomainsRequestParams) {
    return this.http.post<DomainsResponseData>('/terminal/domain-category/domains', data)
  }
  //获取域名分类列表
  getTerminalDomainCategoryList () {
    return this.http.post<CategoryResponseData>('/terminal/domain-category/list', {})
  }
}
